import styled from "styled-components";

export const HelpActionContainer = styled.div`
  text-align: center;
`;

export const Caption = styled.figcaption`
  color: #fff;
  font-family: "Open-Sans", sans-serif;
  font-size: 0.9rem;
`;
